import { Route, Routes, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import './App.css';
import "bootstrap/dist/css/bootstrap.min.css"; // Import Bootstrap CSS

import Home from "./component/TourPackages/HomePage/Home";
import Lists from "./component/TourPackages/ListPage/Lists";
import Detail from "./component/TourPackages/Detailpage/Detail";
import FooterSection from "./component/TourPackages/Footer/FooterSection";
import NavbarMain from "./component/TourPackages/Navbar/NavbarMain";
import FooterClimax from "./component/TourPackages/Footer/FooterClimax";
import AboutUs from './component/TourPackages/AboutUs/AboutUs';
import PrivacyPolicy from './component/TourPackages/PrivacyPolicy/PrivacyPolicy';
import TermCondition from './component/TourPackages/TermsConditions/TermCondition';
import ContactUs from './component/TourPackages/ContactUs/ContactUs';
import SubmenuData from './component/TourPackages/SubmenuPages/SubmenuData';
import PackageDetail from './component/TourPackages/Detailpage/PackageDetail';
import PokharaPackage from './component/TourPackages/PackageDetails/PokharaPackage';
import ManokamnaPackage from './component/TourPackages/PackageDetails/ManokamnaPackage';
import LumbiniPackage from './component/TourPackages/PackageDetails/LumbiniPackage';
import MuktinathTour from './component/TourPackages/PackageDetails/MuktinathTour';
import ChitwanPackage from './component/TourPackages/PackageDetails/ChitwanPackage';
import JanakpurPackage from './component/TourPackages/PackageDetails/JanakpurPackage';
import VaranasiPackage from './component/TourPackages/PackageDetails/VaranasiPackage';
import AyodhyaPackage from './component/TourPackages/PackageDetails/AyodhyaPackage';
import KushinagarPackage from './component/TourPackages/PackageDetails/KushinagarPackage';
import DarjeelingPackage from './component/TourPackages/PackageDetails/DarjeelingPackage';
import SikkimPackage from './component/TourPackages/PackageDetails/SikkimPackage';


// ✅ ScrollToTop component defined here
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to top on route change
  }, [pathname]);

  return null;
};

function App() {
  return (
    <div>
      <ScrollToTop /> {/* Automatically scrolls up on each route change */}
      <NavbarMain />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/:pack" element={<Lists />} />
        <Route path="/:pack/:fullDetails" element={<Detail />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-conditions" element={<TermCondition />} />
        <Route path="/contact" element={<ContactUs />} />
          {/* Dynamic island pages */}
         <Route path="/islands/:island" element={<SubmenuData />} /> 
        <Route path="/kathmandu" element={<PackageDetail />} />
        <Route path="/pokhara" element={<PokharaPackage />} />
        <Route path="/manokamna" element={<ManokamnaPackage />} />
        <Route path="/lumbini" element={<LumbiniPackage />} />
        <Route path="/muktinath" element={<MuktinathTour />} />
        <Route path="/chitwan" element={<ChitwanPackage />} />
        <Route path="/janakpur" element={<JanakpurPackage />} />
        <Route path="/varanasi" element={<VaranasiPackage />} />
        <Route path="/ayodhya" element={<AyodhyaPackage />} />
        <Route path="/kushinagar" element={<KushinagarPackage />} />
        <Route path="/darjeeling" element={<DarjeelingPackage />} />
        <Route path="/sikkim" element={<SikkimPackage />} />

      </Routes>
      <FooterSection />
      <FooterClimax />
    </div>
  );
}

export default App;
